<template>
  <!-- Business Section -->
  <section class="py-16 bg-gradient-to-r from-gray-50 to-gray-100">
    <div class="container mx-auto px-4 flex flex-col md:flex-row items-center">
      <div class="md:w-1/2 mb-8 md:mb-0">
        <h2 class="text-3xl font-bold mb-4 text-[#B89666]">Lexo za strokovnjake</h2>
        <h2 class="text-2xl font-bold text-black mb-4">Izpostavi svoje storitve in <span class="text-blue-400">povečaj svoj domet</span></h2>
        <p class="text-gray-600 mb-6">
          Dinamična platforma, ki te postavi na zemljevid in uporabnika brez stroškov usmeri do vas.
        </p>
        <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
          <a :href="route('web.join-us')" class="text-white">
            <v-icon icon="mdi mdi-account-network" class="mr-2" />Pridruži se
          </a>
        </button> 
      </div>
      <div class="md:w-1/2 flex justify-center">
        <img src="/images/common/join-us-1536x1024.png" class="rounded-lg shadow-lg max-w-md w-full" alt="Lexo za strokovnjake" title="Lexo za strokovnjake"/>
      </div>
    </div>
  </section>
</template>

<script setup>
</script>